/** Short synthesized earcons, so the app needs no audio files. */
let ctx: AudioContext | null = null;
let ringTimer: number | null = null;

function audio(): AudioContext {
  ctx ??= new AudioContext();
  if (ctx.state === 'suspended') void ctx.resume();
  return ctx;
}

function tone(freq: number, start: number, dur: number, gain = 0.08): void {
  const a = audio();
  const osc = a.createOscillator();
  const g = a.createGain();
  osc.type = 'sine';
  osc.frequency.value = freq;
  g.gain.setValueAtTime(0, a.currentTime + start);
  g.gain.linearRampToValueAtTime(gain, a.currentTime + start + 0.02);
  g.gain.exponentialRampToValueAtTime(0.0001, a.currentTime + start + dur);
  osc.connect(g).connect(a.destination);
  osc.start(a.currentTime + start);
  osc.stop(a.currentTime + start + dur + 0.05);
}

export function startRinging(): void {
  stopRinging();
  const ring = () => {
    tone(880, 0, 0.18);
    tone(1175, 0.2, 0.18);
    tone(880, 0.6, 0.18);
    tone(1175, 0.8, 0.18);
  };
  ring();
  ringTimer = window.setInterval(ring, 2200);
}

export function stopRinging(): void {
  if (ringTimer !== null) window.clearInterval(ringTimer);
  ringTimer = null;
}

export function chime(kind: 'connect' | 'end' | 'alert'): void {
  if (kind === 'connect') {
    tone(660, 0, 0.12, 0.06);
    tone(990, 0.12, 0.2, 0.06);
  } else if (kind === 'end') {
    tone(740, 0, 0.12, 0.05);
    tone(494, 0.12, 0.22, 0.05);
  } else {
    tone(523, 0, 0.15, 0.07);
    tone(523, 0.25, 0.15, 0.07);
  }
}
